const en = {
  editable: 'Editable',
  search_field: 'Search field',
  field_not_found: 'Field not found',
  clear: 'Clear',
  align: 'Align',
  add_all_required_fields_to_continue: 'Add all required fields to continue',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Uploaded PDF contains form fields. Keep or remove them?',
  keep: 'Keep',
  left: 'Left',
  validation: 'Validation',
  right: 'Right',
  center: 'Center',
  description: 'Description',
  display_title: 'Display title',
  with_logo: 'With logo',
  unchecked: 'Unchecked',
  type_value: 'Type value',
  equal: 'Equal',
  not_equal: 'Not equal',
  contains: 'Contains',
  does_not_contain: 'Does not contain',
  not_empty: 'Not empty',
  empty: 'Empty',
  select_field_: 'Select field...',
  select_value_: 'Select value...',
  remove_condition: 'Remove condition',
  add_condition: 'Add condition',
  are_you_sure: 'Are you sure?',
  preview: 'Preview',
  sign_yourself: 'Sign Yourself',
  set_signing_date: 'Set signing date',
  set_signing_datetime: 'Set signing date & time',
  set_now: 'Set Now',
  set_today: 'Set Today',
  signing_date: 'Signing Date',
  signing_datetime: 'Signing Date & Time',  
  send: 'Send',
  remove: 'Remove',
  edit: 'Edit',
  settings: 'Settings',
  up: 'Up',
  down: 'Down',
  checked: 'Checked',
  save: 'Save',
  cancel: 'Cancel',
  any: 'Any',
  drawn: 'Drawn',
  formula: 'Formula',
  typed: 'Typed',
  draw_field_on_the_document: 'Draw {field} field on the document',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  uploading: 'Uploading',
  processing_: 'Processing...',
  add_pdf_documents_or_images: 'Add PDF documents or images',
  add_documents_or_images: 'Add documents or images',
  required: 'Required',
  default_value: 'Default value',
  format: 'Format',
  read_only: 'Read-only',
  page: 'Page',
  draw_new_area: 'Draw New Area',
  copy_to_all_pages: 'Copy to All Pages',
  add_option: 'Add option',
  option: 'Option',
  condition: 'Condition',
  first_party: 'First Party',
  second_party: 'Second Party',
  third_party: 'Third Party',
  fourth_party: 'Fourth Party',
  fifth_party: 'Fifth Party',
  sixth_party: 'Sixth Party',
  seventh_party: 'Seventh Party',
  eighth_party: 'Eighth Party',
  ninth_party: 'Ninth Party',
  tenth_party: 'Tenth Party',
  eleventh_party: 'Eleventh Party',
  twelfth_party: 'Twelfth Party',
  thirteenth_party: 'Thirteenth Party',
  fourteenth_party: 'Fourteenth Party',
  fifteenth_party: 'Fifteenth Party',
  sixteenth_party: 'Sixteenth Party',
  seventeenth_party: 'Seventeenth Party',
  eighteenth_party: 'Eighteenth Party',
  nineteenth_party: 'Nineteenth Party',
  twentieth_party: 'Twentieth Party',
  draw: 'Draw',
  add: 'Add',
  or_add_field_without_drawing: 'Or add field without drawing',
  text: 'Text',
  number: 'Number',
  signature: 'Signature',
  initials: 'Initials',
  date: 'Date',
  datetime: 'Date & Time',
  image: 'Image',
  file: 'File',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  payment: 'Payment',
  phone: 'Phone',
  field: 'Field',
  group: 'Group',
  draw_a_text_field_on_the_page_with_a_mouse: 'Draw a text field on the page with a mouse',
  draw_field: 'Draw {field} Field',
  replace: 'Replace',
  uploading_: 'Uploading...',
  add_document: 'Add Document',
  none: 'None',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Custom',
  numbers_only: 'Numbers only',
  letters_only: 'Letters only',
  regexp_validation: 'Regexp validation',
  fill_requirement_field: 'add_all_required_fields_to_continue',
  template_is_empty_and_will_be_deleted: 'Template is empty and will be deleted. Are you sure?'
}
const zh = {
  editable: '可編輯',
  search_field: '搜尋欄',
  field_not_found: '找不到對應的欄位',
  clear: '清除',
  align: '縮排',
  add_all_required_fields_to_continue: '請填寫所有必要欄位內容',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'PDF已設定好簽章的輸入元件. 想要保留或移除? ',
  keep: '保存',
  left: '置左',
  validation: '驗證',
  right: '置右',
  center: '置中',
  description: '描述',
  display_title: '顯示標題',
  with_logo: 'With logo',
  unchecked: '取消選取',
  type_value: '型態值',
  equal: '相等',
  not_equal: '不相等',
  contains: '包含',
  does_not_contain: '不包含',
  not_empty: '不可為空值',
  empty: '可為空值',
  select_field_: '請選擇欄位...',
  select_value_: '請選擇值...',
  remove_condition: '移除條件',
  add_condition: '加入條件',
  are_you_sure: '是否確定?',
  preview: '預覽簽署結果',
  sign_yourself: '自行簽署',
  set_signing_date: '設定為簽署當下的日期',
  set_signing_datetime: '設定為簽署當下的日期與時間',
  set_now: '設定為現在時間',
  set_today: '設定為今天日期',
  signing_date: '簽署當下的日期',
  signing_datetime: '簽署當下的日期與時間',
  send: '傳送',
  remove: '移除',
  edit: '編輯',
  settings: '設定',
  up: '上',
  down: '下',
  checked: '選取',
  save: '儲存',
  cancel: '取消',
  any: '任意',
  drawn: '手寫簽名',
  formula: '公式',
  typed: '打字簽名',
  draw_field_on_the_document: '請在文件上直接畫上{field}',
  click_to_upload: '點選以上傳',
  or_drag_and_drop_files: '或 拖拉檔案至此',
  uploading: '上傳中',
  processing_: '處理中...',
  add_pdf_documents_or_images: '加入PDF文件或圖片檔案',
  add_documents_or_images: '加入文件或圖片檔案',
  required: '必須',
  default_value: '預設值',
  format: '格式',
  read_only: '唯讀',
  page: '頁',
  draw_new_area: '畫上新的區塊',
  copy_to_all_pages: '複製所有頁面',
  add_option: '加入選項',
  option: '選項',
  optional: '選填',
  condition: '條件',
  first_party: '第一位簽署者',
  second_party: '第二位簽署者',
  third_party: '第三位簽署者',
  fourth_party: '第四位簽署者',
  fifth_party: '第五位簽署者',
  sixth_party: '第六位簽署者',
  seventh_party: '第七位簽署者',
  eighth_party: '第八位簽署者',
  ninth_party: '第九位簽署者',
  tenth_party: '第十位簽署者',
  eleventh_party: '第十一位簽署者',
  twelfth_party: '第十二位簽署者',
  thirteenth_party: '第十三位簽署者',
  fourteenth_party: '第十四位簽署者',
  fifteenth_party: '第十五位簽署者',
  sixteenth_party: '第十六位簽署者',
  seventeenth_party: '第十七位簽署者',
  eighteenth_party: '第十八位簽署者',
  nineteenth_party: '第十九位簽署者',
  twentieth_party: '第二十位簽署者',
  draw: '畫',
  add: '加入',
  or_add_field_without_drawing: '或直接點選文件上所要置放的位置',
  text: '文字',
  number: '數字',
  signature: '簽名',
  initials: '姓名的首字母',
  date: '日期',
  datetime: '日期與時間',
  image: '圖片',
  file: '檔案',
  select: '下拉式選單',
  checkbox: '核取方塊',
  multiple: '多選按鈕',
  radio: '單選按鈕',
  cells: '元件',
  stamp: '印章',
  payment: '付款',
  phone: '電話',
  field: '欄位',
  group: '群組',
  draw_a_text_field_on_the_page_with_a_mouse: '請用滑鼠在文件上畫上欄位區塊',
  draw_field: '畫上 {field} 欄位',
  replace: '取代',
  uploading_: '上傳中...',
  add_document: '加入新文件',
  none: '空值',
  ssn: '身分證號',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: '郵遞區號',
  custom: '自訂',
  numbers_only: '限制只能輸入數字',
  letters_only: '限制只能輸入英文文字',
  regexp_validation: 'Regexp驗證',
  fill_requirement_field: '請設定好所有需要簽核或填寫之欄位',
  please_add_fields_for_the : '請加入',
  template_is_empty_and_will_be_deleted: '尚未上傳任何文件，此範本將會被刪除，是否確定？'
}

export { en,zh }
